<nb-card [nbSpinner]="loading" nbSpinnerStatus="info" *ngIf="loaded">
  <nb-card-header>
    <div class="row">
      <div class="col-12 header">
        <h6 class="text-primary">
          Dữ liệu sao lưu mặt hàng - {{ productArchived.title }}
        </h6>

        <button
          class="cancel"
          nbButton
          outline
          status="info"
          size="small"
          (click)="cancel()"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-12 header">
        <ngx-card-value-overview
          [title]="'warehouse.receive' | translate"
          [value]="productArchived.receiveAmount"
          [quantity]="productArchived.receiveQuantity"
          [type]="'info'"
          [icon]="'arrow-circle-up-outline'"
        >
        </ngx-card-value-overview>

        <ngx-card-value-overview
          [title]="'warehouse.issue' | translate"
          [value]="productArchived.issueAmount"
          [quantity]="productArchived.issueQuantity"
          [type]="'warning'"
          [icon]="'arrow-circle-down-outline'"
        >
        </ngx-card-value-overview>

        <ngx-card-value-overview
          [title]="'warehouse.balance' | translate"
          [value]="productArchived.balanceAmount"
          [quantity]="productArchived.balanceQuantity"
          [type]="'primary'"
          [icon]="'trending-up-outline'"
        >
        </ngx-card-value-overview>
      </div>
    </div>

    <div class="row">
      <div class="col-12 form-inline">
        <nb-form-field fullWidth>
          <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            shape="semi-round"
            class="form-control"
            status="info"
            placeholder="{{ 'common.strSearch' | translate }}"
            [(ngModel)]="strSearch"
            #search
          />
        </nb-form-field>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ "common.date" | translate }}</th>
            <th scope="col">{{ "common.description" | translate }}</th>
            <th scope="col" class="col-number">
              {{ "warehouse.receiveQty" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.receiveAmount" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.issueQty" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.issueAmount" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.balanceQty" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.balanceAmount" | translate }}
            </th>
            <th scope="col" class="col-action"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of inventories | filter: strSearch; let i = index"
          >
            <td class="col-no">
              <b class="text-info">
                {{ i + 1 }}
              </b>
              <button
                nbButton
                ghost
                status="danger"
                size="small"
                (click)="remove(item)"
              >
                <nb-icon icon="close-circle-outline"></nb-icon>
              </button>
            </td>
            <td>
              {{ item.issueDate | date: "dd/MM/yyyy" }}
            </td>
            <td>
              <label
                *ngIf="!item.receiptId && !item.purchaseId"
                class="description"
              ></label>
              <a
                *ngIf="item.receiptId || item.purchaseId"
                class="text-primary link text-link"
              >
                {{ item.comment }}
              </a>
            </td>
            <td class="col-number">
              {{ item.receiveQuantity | number }}
            </td>
            <td class="col-number">
              {{ item.receiveAmount | number }}
            </td>
            <td class="col-number">
              {{ item.issueQuantity | number }}
            </td>
            <td class="col-number">
              {{ item.issueAmount | number }}
            </td>
            <td class="col-number">
              <strong> {{ item.balanceQuantity | number }} </strong>
            </td>
            <td class="col-number">
              <strong> {{ item.balanceAmount | number }} </strong>
            </td>

            <td class="col-action"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </nb-card-body>
</nb-card>
